export const vehicleAnalyticReportInitialValues = {
    agrupamento: 1,
    boVeiculoAcessivel: false,
    boExibirProprietario: false,
    boExibirAcessibilidade: false,
    boExibirSituacao: false,
    boExibirIdadeMedia: true,
    boExibirResumo: true,
    dtCadastro: { dtInicio: '', dtFim: '' },
    dtVencimento: { dtInicio: '', dtFim: '' },
    deUtilizacao: '',
    usuarios: [],
    situacaoVeiculos: 1,
    opcaoVistoria: 3,
    subSistemas: [],
    tiposEmpresa: [],
    tiposPessoaFisica: [],
    tiposAcessibilidade: [],
    tiposVeiculo: [],
    placas: [],
};
